/**
 * @format
 */
export const SET_CLIENTS = 'set_clients';
export const TOGGLE_CLIENT_LIST_LOADING = 'toggle_client_list_loading';
export const CHANGE_CLIENT_CURRENT_PAGE = 'change_client_current_page';
